import * as React from 'react';
import Div from "@jumbo/shared/Div";
import ContentWrapper from 'app/components/ContentWrapper/ContentWrapper';
import { Typography } from "@mui/material";
import MobileFooter from 'app/components/MobileFooter/MobileFooter';
import MobileHeader from 'app/components/MobileHeader/MobileHeader';
import { useNavigate } from "react-router-dom";
import ButtonStyled from 'app/components/ButtonStyled/ButtonStyled';
import { setupParams } from 'app/services/setupWebview';
import Swal from 'sweetalert2';
import { isMobile } from 'react-device-detect';
import { useProgram } from 'app/hooks/useProgram';


const WebViewRegistrasiSukses = () => {
	const program = useProgram();

	const navigate = useNavigate();
	
	const [webviewData, setWebviewData] = React.useState(null);
	React.useEffect(() => {
		// if (!isMobile) {
		// 	Swal.fire({
		// 		icon: 'warning',
		// 		title: 'Forbidden!',
		// 		text: 'Halaman ini tidak dapat diakses melalui browser',
		// 		allowOutsideClick: false,
		// 		showConfirmButton: false
		// 	});
		// }
		var parameter = localStorage.getItem('params')
		setupParams(parameter, setWebviewData, false, () => { })
	}, []);

	const navigateToLogin = () => {
		// 👇️ navigate to /demoLoginWebView
		localStorage.removeItem('expiryTime')
		localStorage.removeItem('restartCount')
		navigate('/referrerList?agentCode=' + webviewData.kode);
	};

	const navigateBack = () => {
		localStorage.removeItem('agentCode')
		localStorage.removeItem('token')
		localStorage.removeItem('expiryTime')
		localStorage.removeItem('restartCount')
		window.ReactNativeWebView.postMessage(JSON.stringify('exit webview'));
	}

	return (
		<Div className='page-wrapper-mobile'>

			{/* 🔥 HEADER */}
			<MobileHeader
				backIcon
				headerTx={"Registrasi"}
				backOnClick={navigateBack}
			/>

			{/* 🔥 CONTENT */}
			<ContentWrapper isMobile>
				{/* 🔥 typography */}
				<Typography sx={{ mt: 2 }} fontSize={20} fontWeight={600} textAlign={"center"} color={"black"}>Selamat! Anda Telah Terdaftar Ke Dalam {program}</Typography>

				<Div className='flex-justify-center'>
					<img alt="Registersukses.svg" src={`${process.env.REACT_APP_IMAGES_PATH}/Registersukses.svg`} width={265} height={265} />
				</Div>
			</ContentWrapper>

			{/* 🔥 FOOTER */}
			<MobileFooter>

				<ButtonStyled
					btnText={"Kembali Ke Menu Referral"}
					preset={"primary"}
					onClick={navigateToLogin}
				/>
			</MobileFooter>


		</Div>

	);
};

export default WebViewRegistrasiSukses;